<template>

  <div class="articlemanagement-manage">

    <Card :bordered="false">
      <div slot="title">
        <Row>
          <Col
            :xs="24"
            :sm="24"
            :md="6"
            :lg="6"
          >
          <Divider orientation="left">{{langMap.robotControl[this.lang]}}</Divider>
          </Col>
          <Col
            :xs="24"
            :sm="24"
            :md="18"
            :lg="18"
          >
          <Form :label-width="110">
            <div class="des-cardTittle-box">
              <FormItem
                :label="langMap.serialNumber[this.lang]"
                class="leftFlex"
              >
                <Input
                  v-model.trim="code "
                  :placeholder="langMap.serialNumber[this.lang]"
                  clearable
                />
              </FormItem>
              <FormItem
                :label="langMap.name[this.lang]"
                class="leftFlex"
              >
                <Input
                  v-model.trim="name"
                  :placeholder="langMap.name[this.lang]"
                  clearable
                />
              </FormItem>
              <FormItem
                :label="langMap.modelNumber[this.lang]"
                class="leftFlex"
              >
                <Input
                  v-model.trim="type"
                  :placeholder="langMap.modelNumber[this.lang]"
                  clearable
                />
              </FormItem>
              <Button
                type="info"
                style="margin-left:20px;"
                @click="searchData"
              >{{langMap.search[this.lang]}}</Button>
            </div>
          </Form>
          </Col>
        </Row>
      </div>
      <Table
        :height="height"
        :loading="tableLoading"
        border
        :columns="col"
        :data="robotList"
      ></Table>
      <!--分页数据-->
      <div
        style="text-align:center;padding-top:10px;"
        v-if="robotList.length>0"
      >
        <Page
          :current="index"
          :total="total"
          :page-size="15"
          @on-change="goPageData"
        ></Page>
      </div>
    </Card>

    <Modal
      v-model="versionModal"
      :title="langMap.versionInfo[this.lang]"
      @on-ok="ok"
      @on-cancel="cancel"
    >
      <ul>
        <li class="li"><a href="#">{{langMap.mcuVersion[this.lang]}}：</a><span>{{version.mcu}}</span></li>
        <li class="li"><a href="#">{{langMap.systemVersion[this.lang]}}：</a><span>{{version.system}}</span></li>
        <li class="li"><a href="#">{{langMap.powerModuleVersion[lang]}}：</a><span>{{version.power}}</span></li>
        <li class="li"><a href="#">{{langMap.controlModuleVersion[lang]}}：</a><span>{{version.control}}</span></li>
        <li class="li"><a href="#">{{langMap.navigationModuleVersion[lang]}}：</a><span>{{version.navigation}}</span></li>
        <li class="li"><a href="#">{{langMap.perceptionModuleVersion[lang]}}：</a><span>{{version.perception}}</span></li>
        <li class="li"><a href="#">{{langMap.communicationModuleVersion[lang]}}：</a><span>{{version.communication}}</span></li>
        <li class="li"><a href="#">{{langMap.voiceFileVersion[lang]}}：</a><span>{{version.voice}}</span></li>
        <li class="li"><a href="#">{{langMap.workAreaVersion[lang]}}：</a><span>{{version.workArea}}</span></li>
      </ul>
      <div slot="footer">
        <Button
          type="info"
          @click="versionModal = false"
        >{{langMap.confirm[lang]}}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import api from "../../../api";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
import { connectWithUrl, sendMsg } from '@/utils/websocket';
import { getTenantId } from "@/libs/util";
export default {
  components: {},
  data() {
    return {
      langMap:langMap,
      height: document.documentElement.clientHeight - 300,
      versionModal: false,
      version: {},
      robotList: [],
      index: 1,
      total: 0,
      //表格
      tableLoading: false,
      code: "",
      name: "",
      type: "",
      socket: null
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language
    }),
    col () {
      return [
        {
          title: "#",
          width: 60,
          key: "index",
          align: "center",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.robotStatus[this.lang],
          width: 105,
          align: "center",
          key: "offlineStatus",
          render:(h, params) => {
            let statusClass = '';
            let dotClass = '';
            let statusText = '';
            const offlineStatus = params.row.onlineStatus;
            if ([null, undefined].includes(offlineStatus)) {
              statusClass = 'tech-status status-unknown';
              dotClass = 'status-dot dot-unknown';
              statusText = langMap.unknown[this.lang];
            } else if (offlineStatus) {
              statusClass = 'tech-status status-online';
              dotClass = 'status-dot dot-online';
              statusText = langMap.online[this.lang];
            } else {
              statusClass = 'tech-status status-offline';
              dotClass = 'status-dot dot-offline';
              statusText = langMap.offline[this.lang];
            }

            return h('div', {
              class: statusClass
            }, [
              // 扫描线效果
              h('div', {
                class: 'scan-line'
              }),
              // 数据流背景
              h('div', {
                class: 'data-flow'
              }),
              // 状态指示点
              h('span', {
                class: dotClass
              }),
              // 状态文本
              h('span', {
                class: 'status-text'
              }, statusText)
            ]);
          }
        },
        {
          title: langMap.serialNumber[this.lang],
          width: 180,
          align: "center",
          key: "code" // productId
        },
        {
          title: langMap.name[this.lang],
          width: 160,
          align: "center",
          key: "name"
        },
        {
          title: langMap.modelNumber[this.lang],
          minWidth:90,
          align: "center",
          key: "type"
        },
        {
          width: 300,
          title: langMap.versionInfo[this.lang],
          align: "center",
          render: (h, params) => {
            let version = {};
            let versionClass = 'version-tag';

            if (params.row.versionDTO) {
              // 版本信息
              version = params.row.versionDTO;
            }
            // 如果没有版本信息，应用空版本样式
            if (!version.softwareVersion) {
              versionClass += ' empty-version';
            }

            return h("div", {
              class: versionClass,
              attrs: {
                title: version.softwareVersion || langMap.empty[this.lang] // 添加悬停提示
              }
            }, version.softwareVersion || langMap.empty[this.lang]);
          }
        },
        // {
        //   width: 80,
        //   title: langMap.powerOperation[this.lang],
        //   align: "center",
        //   render: (h, params) => {
        //     //渲染数组
        //     let renderArray = [];
        //     renderArray.push(
        //       h(
        //         "Button",
        //         {
        //           props: {
        //             type: "success",
        //             size: "small",
        //             disabled: true
        //           },
        //           class: "sci-fi-btn power-on-btn",
        //           style: {
        //             marginLeft: "5px"
        //           },
        //           on: {
        //             click: () => {
        //               // params.row
        //               this.$Modal.confirm({
        //                 title: langMap.systemTip[this.lang],
        //                 content: langMap.confirmPowerOn[this.lang],
        //                 okText: langMap.confirm[this.lang],
        //                 cancelText: langMap.cancel[this.lang],
        //                 onOk: () => {
        //                   let data = {
        //                     robotId: params.row.id
        //                   };
        //                   this.$Spin.show();
        //                   api
        //                     .postData("notice-server/cmd/on", data, this)
        //                     .then(res => {
        //                       if (res.state == 0) {
        //                         this.$Notice.error({
        //                           title: langMap.tip[this.lang],
        //                           desc: res.msg
        //                         });
        //                       } else {
        //                         this.$Notice.success({
        //                           title: langMap.success[this.lang],
        //                           desc: res.message
        //                         });
        //                         this.getList();
        //                       }
        //                       this.$Spin.hide();
        //                     });
        //                 }
        //               });
        //             }
        //           }
        //         },
        //         langMap.on[this.lang]
        //       )
        //     );
        //     renderArray.push(
        //       h(
        //         "Button",
        //         {
        //           props: {
        //             type: "error",
        //             size: "small",
        //             disabled: true
        //           },
        //           class: "sci-fi-btn power-off-btn",
        //           style: {
        //             marginLeft: "5px"
        //           },
        //           on: {
        //             click: () => {
        //               this.$Modal.confirm({
        //                 title: langMap.systemTip[this.lang],
        //                 content: langMap.confirmPowerOn[this.lang],
        //                 okText: langMap.confirm[this.lang],
        //                 cancelText: langMap.cancel[this.lang],
        //                 onOk: () => {
        //                   let data = {
        //                     robotId: params.row.id
        //                   };
        //                   this.$Spin.show();
        //                   api
        //                     .postData("notice-server/cmd/off", data, this)
        //                     .then(res => {
        //                       if (res.state == 0) {
        //                         this.$Notice.error({
        //                           title: langMap.tip[this.lang],
        //                           desc: res.msg
        //                         });
        //                       } else {
        //                         this.$Notice.success({
        //                           title: langMap.success[this.lang],
        //                           desc: res.message
        //                         });
        //                         this.getList();
        //                       }
        //                       this.$Spin.hide();
        //                     });
        //                 }
        //               });
        //             }
        //           }
        //         },
        //         langMap.off[this.lang]
        //       )
        //     );
        //     return h("div", renderArray);
        //   }
        // },
        {
          width: (this.lang == 'zh' ? 100 : 165), 
          title: langMap.fireNetGun[this.lang],
          align: "center",
          fixed: "right",
          render: (h, params) => {
            //渲染数组
            let renderArray = [];
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  class: "sci-fi-btn netgun-btn",
                  style: {
                    marginLeft: "5px"
                    // display: "inline-block" // Ensure inline display
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.confirmFireLeftNetGun[this.lang],
                        okText: langMap.confirm[this.lang],
                        cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          this.$Spin.show();
                          this.sendBatchCommand(params.row.code,
                          [
                            {
                              "deviceType": 1, // 1-网枪
                              "devicePosition": 4, // 4-左前
                              "operate": 1, // 1-开启
                              "duration": 3000 // ms
                            }
                          ]
                        );
                        }
                      });
                    }
                  }
                },
                langMap.leftFront[this.lang]
              )
            );
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  class: "sci-fi-btn netgun-btn",
                  style: {
                    marginLeft: "5px"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.confirmFireRightNetGun[this.lang],
                        okText: langMap.confirm[this.lang],
                        cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          this.$Spin.show();
                          this.sendBatchCommand(params.row.code,
                          [
                            {
                              "deviceType": 1, // 1-网枪
                              "devicePosition": 7, // 7-右后
                              "operate": 1, // 1-开启
                              "duration": 3000 // ms
                            }
                          ]
                        );
                        }
                      });
                    }
                  }
                },
                langMap.rightRear[this.lang]
              )
            );
            return h("div", renderArray);
          }
        },
        {
          width: (this.lang == 'zh' ? 100 : 165), 
          title: langMap.tripwire[this.lang],
          align: "center",
          fixed: "right",
          render: (h, params) => {
            //渲染数组
            let renderArray = [];
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  class: "sci-fi-btn netgun-btn",
                  style: {
                    marginLeft: "5px"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.confirmTripwireLeftFront[this.lang],
                        okText: langMap.confirm[this.lang],
                        cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          this.$Spin.show();
                          this.sendBatchCommand(params.row.code,
                          [
                            {
                              "deviceType": 2, // 2-绊马索
                              "devicePosition": 4, // 4-左前
                              "operate": 1, // 1-开启
                              "duration": 3000 // ms
                            }
                          ]
                        );
                        }
                      });
                    }
                  }
                },
                langMap.leftFront[this.lang]
              )
            );
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  class: "sci-fi-btn netgun-btn",
                  style: {
                    marginLeft: "5px"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.confirmTripwireRightRear[this.lang],
                        okText: langMap.confirm[this.lang],
                        cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          this.$Spin.show();
                          this.sendBatchCommand(params.row.code,
                          [
                            {
                              "deviceType": 2, // 2-绊马索
                              "devicePosition": 7, // 7-右后
                              "operate": 1, // 1-开启
                              "duration": 3000 // ms
                            }
                          ]
                        );
                        }
                      });
                    }
                  }
                },
                langMap.rightRear[this.lang]
              )
            );
            return h("div", renderArray);
          }
        },
        {
          width: 80, // Increased width to accommodate buttons on one line
          title: langMap.lightControl[this.lang],
          align: "center",
          fixed: "right",
          render: (h, params) => {
            //渲染数组
            let renderArray = [];
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small"
                  },
                  class: "sci-fi-btn light-on-btn",
                  style: {
                    marginLeft: "5px",
                    // display: "inline-block" // Ensure inline display
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.confirmLightOn[this.lang],
                        okText: langMap.confirm[this.lang],
                        cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          this.$Spin.show();
                          this.sendBatchCommand(params.row.code,
                          [
                            {
                              "deviceType": 3, // 3-灯
                              "devicePosition": 2, // 2-前
                              "operate": 1, // 1-开启
                              "duration": 0 // ms
                            },
                            {
                              "deviceType": 3, // 3-灯
                              "devicePosition": 3, // 3-后
                              "operate": 1, // 1-开启
                              "duration": 0 // ms
                            }
                          ]
                        );
                        }
                      });
                    }
                  }
                },
                langMap.on[this.lang]
              )
            );
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                  },
                  class: "sci-fi-btn light-off-btn",
                  style: {
                    marginLeft: "5px"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.confirmLightOff[this.lang],
                        okText: langMap.confirm[this.lang],
                        cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          this.$Spin.show();
                          this.sendBatchCommand(params.row.code,
                          [
                            {
                              "deviceType": 3, // 3-灯
                              "devicePosition": 2, // 2-前
                              "operate": 0, // 0-关闭
                              "duration": 0 // ms
                            },
                            {
                              "deviceType": 3, // 3-灯
                              "devicePosition": 3, // 3-后
                              "operate": 0, // 0-关闭
                              "duration": 0 // ms
                            }
                          ]
                        );
                        }
                      });
                    }
                  }
                },
                langMap.off[this.lang]
              )
            );
            return h("div", renderArray);
          }
        },
        // {
        //   width: 80,
        //   title: langMap.alarmControl[this.lang],
        //   align: "center",
        //   render: (h, params) => {
        //     //渲染数组
        //     let renderArray = [];
        //     renderArray.push(
        //       h(
        //         "Button",
        //         {
        //           props: {
        //             type: "success",
        //             size: "small",
        //             disabled: true
        //           },
        //           class: "sci-fi-btn alarm-on-btn",
        //           style: {
        //             marginLeft: "5px"
        //           },
        //           on: {
        //             click: () => {
        //               let data = {
        //                 robotId: params.row.id,
        //                 data: 1
        //               };
        //               this.$Spin.show();
        //               api
        //                 .postData("notice-server/cmd/alarm", data, this)
        //                 .then(res => {
        //                   if (res.state == 0) {
        //                     this.$Notice.error({
        //                       title: langMap.tip[this.lang],
        //                       desc: res.msg
        //                     });
        //                   } else {
        //                     this.$Notice.success({
        //                       title: langMap.success[this.lang],
        //                       desc: res.message
        //                     });
        //                     this.getList();
        //                   }
        //                   this.$Spin.hide();
        //                 });
        //             }
        //           }
        //         },
        //         langMap.on[this.lang]
        //       )
        //     );
        //     renderArray.push(
        //       h(
        //         "Button",
        //         {
        //           props: {
        //             type: "error",
        //             size: "small",
        //             disabled: true
        //           },
        //           class: "sci-fi-btn alarm-off-btn",
        //           style: {
        //             marginLeft: "5px"
        //           },
        //           on: {
        //             click: () => {
        //               let data = {
        //                 robotId: params.row.id,
        //                 data: 2
        //               };
        //               this.$Spin.show();
        //               api
        //                 .postData("notice-server/cmd/alarm", data, this)
        //                 .then(res => {
        //                   if (res.state == 0) {
        //                     this.$Notice.error({
        //                       title: langMap.tip[this.lang],
        //                       desc: res.msg
        //                     });
        //                   } else {
        //                     this.$Notice.success({
        //                       title: langMap.success[this.lang],
        //                       desc: res.message
        //                     });
        //                     this.getList();
        //                   }
        //                   this.$Spin.hide();
        //                 });
        //             }
        //           }
        //         },
        //         langMap.off[this.lang]
        //       )
        //     );
        //     return h("div", renderArray);
        //   }
        // },
        // {
        //   width: 80,
        //   title: langMap.videoControl[this.lang],
        //   align: "center",
        //   render: (h, params) => {
        //     //渲染数组
        //     let renderArray = [];
        //     renderArray.push(
        //       h(
        //         "Button",
        //         {
        //           props: {
        //             type: "success",
        //             size: "small",
        //             disabled: true
        //           },
        //           class: "sci-fi-btn power-on-btn",
        //           style: {
        //             marginLeft: "5px"
        //           },
        //           on: {
        //             click: () => {
        //               // params.row
        //               this.$Modal.confirm({
        //                 title: langMap.systemTip[this.lang],
        //                 content: langMap.confirmLightOn[this.lang],
        //                 okText: langMap.confirm[this.lang],
        //                 cancelText: langMap.cancel[this.lang],
        //                 onOk: () => {
        //                   let data = {
        //                     robotId: params.row.id
        //                   };
        //                   this.$Spin.show();
        //                   api
        //                     .postData("notice-server/cmd/on", data, this)
        //                     .then(res => {
        //                       if (res.state == 0) {
        //                         this.$Notice.error({
        //                           title: langMap.tip[this.lang],
        //                           desc: res.msg
        //                         });
        //                       } else {
        //                         this.$Notice.success({
        //                           title: langMap.success[this.lang],
        //                           desc: res.message
        //                         });
        //                         this.getList();
        //                       }
        //                       this.$Spin.hide();
        //                     });
        //                 }
        //               });
        //             }
        //           }
        //         },
        //         langMap.on[this.lang]
        //       )
        //     );
        //     renderArray.push(
        //       h(
        //         "Button",
        //         {
        //           props: {
        //             type: "error",
        //             size: "small",
        //             disabled: true
        //           },
        //           class: "sci-fi-btn power-off-btn",
        //           style: {
        //             marginLeft: "5px"
        //           },
        //           on: {
        //             click: () => {
        //               this.$Modal.confirm({
        //                 title: langMap.systemTip[this.lang],
        //                 content: langMap.confirmPowerOn[this.lang],
        //                 okText: langMap.confirm[this.lang],
        //                 cancelText: langMap.cancel[this.lang],
        //                 onOk: () => {
        //                   let data = {
        //                     robotId: params.row.id
        //                   };
        //                   this.$Spin.show();
        //                   api
        //                     .postData("notice-server/cmd/off", data, this)
        //                     .then(res => {
        //                       if (res.state == 0) {
        //                         this.$Notice.error({
        //                           title: langMap.tip[this.lang],
        //                           desc: res.msg
        //                         });
        //                       } else {
        //                         this.$Notice.success({
        //                           title: langMap.success[this.lang],
        //                           desc: res.message
        //                         });
        //                         this.getList();
        //                       }
        //                       this.$Spin.hide();
        //                     });
        //                 }
        //               });
        //             }
        //           }
        //         },
        //         langMap.off[this.lang]
        //       )
        //     );
        //     return h("div", renderArray);
        //   }
        // },
        // {
        //   width: 80,
        //   title: langMap.rectangularTask[this.lang],
        //   align: "center",
        //   render: (h, params) => {
        //     //渲染数组
        //     let renderArray = [];
        //     renderArray.push(
        //       h(
        //         "Button",
        //         {
        //           props: {
        //             type: "error",
        //             size: "small",
        //             disabled: true
        //           },
        //           class: "sci-fi-btn power-off-btn",
        //           style: {
        //             marginLeft: "5px"
        //           },
        //           on: {
        //             click: () => {
        //               let data = {
        //                 robotId: params.row.id,
        //                 data: 1
        //               };
        //               this.$Spin.show();
        //               api
        //                 .postData("notice-server/cmd/alert/task/kill", data, this)
        //                 .then(res => {
        //                   if (res.state == 0) {
        //                     this.$Notice.error({
        //                       title: langMap.tip[this.lang],
        //                       desc: res.msg
        //                     });
        //                   } else {
        //                     this.$Notice.success({
        //                       title: langMap.success[this.lang],
        //                       desc: res.message
        //                     });
        //                     this.getList();
        //                   }
        //                   this.$Spin.hide();
        //                 });
        //             }
        //           }
        //         },
        //         langMap.terminate[this.lang]
        //       )
        //     );
        //     return h("div", renderArray);
        //   }
        // },
        {
          width: 90,
          title: langMap.speaker[this.lang],
          align: "center",
          fixed: "right",
          render: (h, params) => {
            const offline = params.row.onlineStatus != true ||  ![true,false].includes(params.row.speakerState);
            if (offline) {
              return h("span", langMap.unknown[this.lang]);
            }
            let speakerState = params.row.speakerState;
            return h("i-switch", {
              props: {
                value: speakerState === true,
                size: "large",
                loading: params.row.speakerLoading,
                // 关键点：拦截默认的切换行为，改为手动控制
                beforeChange: () => {
                  return new Promise((resolve, reject) => {
                    const currentState = speakerState === true;
                    const nextState = !currentState;
                    this.$Modal.confirm({
                      title: langMap.systemTip[this.lang],
                      content: nextState ? langMap.confirmSpeakerOn[this.lang] : langMap.confirmSpeakerOff[this.lang],
                      okText: langMap.confirm[this.lang],
                      cancelText: langMap.cancel[this.lang],
                      onOk: () => {
                        this.setSpeakerState(params.row, nextState).finally(() => {
                          reject();
                        });
                      },
                      onCancel: () => {
                        reject(); // 取消不切换
                      }
                    });
                  });
                }
              },
              scopedSlots: {
                open: () => h("span", langMap.on[this.lang]),
                close: () => h("span", langMap.off[this.lang])
              }
            });
          }
        },
        {
          width: (this.lang == 'zh' ? 90 : 110),
          title: langMap.ntpSync[this.lang],
          align: "center",
          fixed: "right",
          render: (h, params) => {
            return h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small"
                },
                class: "sci-fi-btn ntp-sync-btn",
                style: {
                  marginLeft: "5px"
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: langMap.systemTip[this.lang],
                      content: langMap.confirmNtpSync[this.lang],
                      okText: langMap.confirm[this.lang],
                      cancelText: langMap.cancel[this.lang],
                      onOk: () => {
                        this.$Spin.show();
                        api
                          .postData("notice-server/cmd/ntp", { code: params.row.code }, this)
                          .then(res => {
                            if (res.state == 0) {
                              this.$Notice.error({
                                title: langMap.tip[this.lang],
                                desc: res.msg
                              });
                            } else {
                              this.$Notice.success({
                                title: langMap.success[this.lang],
                                desc: res.message
                              });
                            }
                            this.$Spin.hide();
                          });
                      }
                    });
                  }
                }
              },
              langMap.ntpSync[this.lang]
            );
          }
        },
        {
          width: (this.lang == 'zh' ? 80 : 120),
          title: langMap.returnToBase[this.lang],
          align: "center",
          fixed: "right",
          render: (h, params) => {
            //渲染数组
            let renderArray = [];
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small"
                  },
                  class: "sci-fi-btn return-base-btn",
                  style: {
                    marginLeft: "5px"
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.confirmReturnToBase[this.lang],
                        okText: langMap.confirm[this.lang],
                        cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          let data = {
                            robotId: params.row.id
                          };
                          this.$Spin.show();
                          api
                            .postData("notice-server/cmd/goBackStation", data, this)
                            .then(res => {
                              if (res.state == 0) {
                                this.$Notice.error({
                                  title: langMap.tip[this.lang],
                                  desc: res.msg
                                });
                              } else {
                                this.$Notice.success({
                                  title: langMap.success[this.lang],
                                  desc: res.message
                                });
                                this.getList();
                              }
                              this.$Spin.hide();
                            });
                        }
                      });
                    }
                  }
                },
                langMap.returnToBase[this.lang]
              )
            );
            return h("div", renderArray);
          }
        }
      ]
    }
  },
  methods: {
    //获取列表
    getList() {
      this.tableLoading = true;
      api
        .getData(
          "robot-server/robot/list?version=1&index=" +
            this.index +
            "&code=" +
            this.code +
            "&name=" +
            this.name +
            "&type=" +
            this.type,
          this
        )
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.robotList = res.data.rows;
            this.total = res.data.total;
          }
          this.tableLoading = false;
        });
    },
    //搜索数据
    searchData() {
      this.index = 1;
      this.getList();
    },
    //分页数据
    goPageData(index) {
      this.index = index;
      this.getList();
    },
    setSpeakerState(row, state) {
      this.$set(row, 'speakerLoading', true);
      const params = {
        code: row.code,
        data: {
          speakerState: state
        }
      };
      return api.postData("notice-server/cmd/speaker/set", params, this).then(res => {
        this.$set(row, 'speakerLoading', false);
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
          return Promise.reject();
        } else {
          this.$Notice.success({
            title: langMap.success[this.lang],
            desc: res.message
          });
          this.refreshSpeakerState(row.code);
          return Promise.resolve();
        }
      }).catch(err => {
        this.$set(row, 'speakerLoading', false);
        return Promise.reject(err);
      });
    },
    refreshSpeakerState(code) {
      sendMsg('robotStatus', {
        type: 'refresh_speaker_state',
        robotCode: code
      });
    },
    initWebSocket() {
      const userId = this.$store.state.user.userInfo.userId;
      const initMsg = JSON.stringify({
        type: "init",
        data: userId,
        language: this.lang,
        tenantId: getTenantId()
      });

      // 根据文档，连接地址是 ws://服务器地址:18014/robotStatus
      // connectWithUrl 内部会拼接基础 URL
      connectWithUrl('/robotStatus', 'robotStatus', initMsg, (res) => {
        try {
          const msg = JSON.parse(res);
          this.handleSocketMessage(msg);
        } catch (e) {
          console.error('解析WebSocket消息失败', e);
        }
      }, (socket) => {
        this.socket = socket;
      });
    },
    handleSocketMessage(msg) {
      if (msg.type === 'speaker_state') {
        const { speakerState } = msg.data;
        const index = this.robotList.findIndex(item => item.code === msg.robotCode);
        if (index !== -1) {
          // 使用 Vue.set 确保响应式更新
          this.$set(this.robotList[index], 'speakerState', speakerState);
        }
      } else if (msg.type === 'robot_online' || msg.type === 'robot_offline') {
        const index = this.robotList.findIndex(item => item.code === msg.robotCode);
        if (index !== -1) {
          this.$set(this.robotList[index], 'onlineStatus', msg.type === 'robot_online');
        }
      }
    },
    sendBatchCommand(code,switchDeviceList){
      const params = {
        code,
        data: {
          switchDeviceList
        }
      }
      api
        .postData("notice-server/cmd/switch/device", params, this)
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.$Notice.success({
              title: langMap.success[this.lang],
              desc: res.message
            });
            this.getList();
          }
          this.$Spin.hide();
        });
    },
    modelShow(flag, data) {
      if (data) {
        this.saveForm = { ...data };
      } else {
        this.saveForm = {
          id: "",
          code: "",
          name: "",
          type: "",
          description: ""
        };
      }
      this.saveModal = flag;
      this.$refs["formValidate"].resetFields();
    },
    ok() {
      this.$refs["formValidate"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          api
            .postData("robot-server/robot/save", this.saveForm, this)
            .then(res => {
              this.btnLoading = false;
              if (res.state == 0) {
                this.$Notice.error({
                  title: langMap.systemTip[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: langMap.systemTip[this.lang],
                  desc: langMap.operateSuccess[this.lang]
                });
                this.getList();
                this.saveModal = false;
              }
            });
        }
      });
    },
    cancel() {
      //this.$Message.info('Clicked cancel');
      this.saveModal = false;
    }
  },
  created() {
    this.getList();
    this.initWebSocket();
  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.close();
    }
  }
};
</script>

<style  lang="less">
.articlemanagement-manage {
  padding: 15px;
  background-color: #f8f8f9;

  .ivu-table-cell {
    padding-left: 2px;
    padding-right: 2px;
    overflow: visible;
  }
  /* 高科技感状态指示器 */
.tech-status {
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  font-family: 'Arial', sans-serif;
  font-weight: bold;
  letter-spacing: 0.5px;
  min-width: 80px;
  justify-content: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

/* 状态指示器背景效果 */
.tech-status::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.05) 25%, transparent 25%, transparent 50%, rgba(0, 0, 0, 0.05) 50%, rgba(0, 0, 0, 0.05) 75%, transparent 75%);
  background-size: 4px 4px;
  z-index: 0;
  opacity: 0.3;
}

/* 状态指示器边框发光效果 */
.tech-status::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid;
  z-index: 1;
  pointer-events: none;
}

/* 在线状态 */
.status-online {
  background-color: rgba(25, 190, 107, 0.15);
  color: #19be6b;
}

.status-online::after {
  border-color: rgba(25, 190, 107, 0.5);
  box-shadow: 0 0 8px rgba(25, 190, 107, 0.3);
}

/* 离线状态 */
.status-offline {
  background-color: rgba(237, 64, 20, 0.15);
  color: #ed4014;
}

.status-offline::after {
  border-color: rgba(237, 64, 20, 0.5);
  box-shadow: 0 0 8px rgba(237, 64, 20, 0.3);
}

/* 未知状态 - 改为黄色 */
.status-unknown {
  background-color: rgba(255, 204, 0, 0.15);
  color: #f59300;
}

.status-unknown::after {
  border-color: rgba(255, 204, 0, 0.5);
  box-shadow: 0 0 8px rgba(255, 204, 0, 0.3);
}

/* 状态指示点 */
.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 8px;
  position: relative;
  display: inline-block;
}

/* 在线状态指示点 */
.dot-online {
  background-color: #19be6b;
  box-shadow: 0 0 0 rgba(25, 190, 107, 0.4);
  animation: pulse-green 1.5s infinite;
}

/* 离线状态指示点 */
.dot-offline {
  background-color: #ed4014;
  box-shadow: 0 0 0 rgba(237, 64, 20, 0.4);
  animation: pulse-red 1.5s infinite;
}

/* 未知状态指示点 - 改为黄色 */
.dot-unknown {
  background-color: #ffcc00;
  box-shadow: 0 0 0 rgba(255, 204, 0, 0.4);
  animation: pulse-yellow 1.5s infinite;
}

/* 在线状态指示点 */
.dot-online {
  background-color: #19be6b;
  box-shadow: 0 0 0 rgba(25, 190, 107, 0.4);
  animation: pulse-green 1.5s infinite;
}

/* 离线状态指示点 */
.dot-offline {
  background-color: #ed4014;
  box-shadow: 0 0 0 rgba(237, 64, 20, 0.4);
  animation: pulse-red 1.5s infinite;
}

/* 扫描线动画 */
.tech-status .scan-line {
  position: absolute;
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, transparent, currentColor, transparent);
  top: 0;
  left: 0;
  opacity: 0.6;
  z-index: 2;
}

.status-online .scan-line {
  animation: scan-green 2s linear infinite;
}

.status-offline .scan-line {
  animation: scan-red 2s linear infinite;
}

/* 指示点脉冲动画 */
@keyframes pulse-green {
  0% {
    box-shadow: 0 0 0 0 rgba(25, 190, 107, 0.7);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(25, 190, 107, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(25, 190, 107, 0);
  }
}

@keyframes pulse-red {
  0% {
    box-shadow: 0 0 0 0 rgba(237, 64, 20, 0.7);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(237, 64, 20, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(237, 64, 20, 0);
  }
}

/* 添加黄色脉冲动画 */
@keyframes pulse-yellow {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 204, 0, 0.7);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(255, 204, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 204, 0, 0);
  }
}

/* 扫描线动画 */
@keyframes scan-green {
  0% {
    top: -2px;
  }
  100% {
    top: 100%;
  }
}

@keyframes scan-red {
  0% {
    top: -2px;
  }
  100% {
    top: 100%;
  }
}

/* 数据流背景效果 */
.tech-status .data-flow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom,
    transparent 0%,
    transparent 45%,
    rgba(255, 255, 255, 0.1) 50%,
    transparent 55%,
    transparent 100%);
  background-size: 100% 20px;
  z-index: 1;
  opacity: 0.3;
}

.status-online .data-flow {
  animation: data-flow 1s linear infinite;
}

@keyframes data-flow {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 0 20px;
  }
}

/* 状态文本 */
.status-text {
  position: relative;
  z-index: 3;
  font-size: 12px;
}

/* 版本信息显示样式 */
.version-tag {
  position: relative;
  display: inline-block;
  padding: 5px 10px;
  background: rgba(45, 140, 240, 0.1);
  border-radius: 4px;
  color: #2d8cf0;
  font-weight: bold;
  border-left: 3px solid #2d8cf0;
  box-shadow: 0 2px 8px rgba(45, 140, 240, 0.2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.3s ease;
}

.version-tag::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: linear-gradient(90deg,
    rgba(45, 140, 240, 0.1) 0%,
    rgba(45, 140, 240, 0) 50%,
    rgba(45, 140, 240, 0.1) 100%);
  background-size: 200% 100%;
  animation: shimmer 2s infinite;
  pointer-events: none;
}

.version-tag:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(45, 140, 240, 0.3);
}

.empty-version {
  background: rgba(144, 147, 153, 0.1);
  color: #909399;
  border-left: 3px solid #909399;
  box-shadow: 0 2px 8px rgba(144, 147, 153, 0.2);
}

.empty-version::before {
  background: linear-gradient(90deg,
    rgba(144, 147, 153, 0.1) 0%,
    rgba(144, 147, 153, 0) 50%,
    rgba(144, 147, 153, 0.1) 100%);
}

@keyframes shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

/* 科幻按钮样式 */
.sci-fi-btn {
  position: relative;
  overflow: hidden;
  border: none !important;
  border-radius: 6px !important;
  font-weight: 500;
  letter-spacing: 1px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
  min-width: 29px;
  min-height: 29px;
}

.sci-fi-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s;
  z-index: 1;
}

.sci-fi-btn:hover::before {
  left: 100%;
}

.sci-fi-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
}

.sci-fi-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

/* 开启按钮样式 - 统一使用绿色 */
.power-on-btn:not([disabled]), .light-on-btn:not([disabled]), .alarm-on-btn:not([disabled]), .task-resume-btn:not([disabled]), .return-base-btn:not([disabled]) {
  background: linear-gradient(135deg, #00ff88, #00cc6a) !important;
  border-color: #00ff88 !important;
  color: white !important;
  box-shadow: 0 4px 15px rgba(0, 255, 136, 0.4);
}

.power-on-btn:not([disabled]):hover, .light-on-btn:not([disabled]):hover, .alarm-on-btn:not([disabled]):hover, .task-resume-btn:not([disabled]):hover, .return-base-btn:not([disabled]):hover {
  background: linear-gradient(135deg, #00cc6a, #00ff88) !important;
  box-shadow: 0 8px 25px rgba(0, 255, 136, 0.6);
}

/* 关闭按钮样式 - 统一使用红色 */
.power-off-btn:not([disabled]), .light-off-btn:not([disabled]), .alarm-off-btn:not([disabled]), .task-pause-btn:not([disabled]) {
  background: linear-gradient(135deg, #ff4757, #ff3742) !important;
  border-color: #ff4757 !important;
  color: white !important;
  box-shadow: 0 4px 15px rgba(255, 71, 87, 0.4);
}

.power-off-btn:not([disabled]):hover, .light-off-btn:not([disabled]):hover, .alarm-off-btn:not([disabled]):hover, .task-pause-btn:not([disabled]):hover {
  background: linear-gradient(135deg, #ff3742, #ff4757) !important;
  box-shadow: 0 8px 25px rgba(255, 71, 87, 0.6);
}

/* disabled状态的按钮样式 */
.sci-fi-btn[disabled] {
  background: linear-gradient(135deg, #c5c8ce, #a8abb2) !important;
  border-color: #c5c8ce !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(197, 200, 206, 0.2) !important;
  cursor: not-allowed !important;
}

.sci-fi-btn[disabled]::before {
  display: none !important;
}

.sci-fi-btn[disabled]:hover {
  transform: none !important;
  box-shadow: 0 2px 8px rgba(197, 200, 206, 0.2) !important;
}

/* 网枪按钮样式 - 保持浅蓝色 */
.netgun-btn:not([disabled]) {
  background: linear-gradient(135deg, #00d4ff, #0099cc) !important;
  border-color: #00d4ff !important;
  color: white !important;
  box-shadow: 0 4px 15px rgba(0, 212, 255, 0.4);
  position: relative;
}

.netgun-btn:not([disabled])::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.3s ease;
}

.netgun-btn:not([disabled]):hover {
  background: linear-gradient(135deg, #0099cc, #00d4ff) !important;
  box-shadow: 0 8px 25px rgba(0, 212, 255, 0.6);
}

/* NTP同步按钮样式 */
.ntp-sync-btn:not([disabled]) {
  background: linear-gradient(135deg, #2d8cf0, #1c6dd0) !important;
  border-color: #2d8cf0 !important;
  color: white !important;
  box-shadow: 0 4px 15px rgba(45, 140, 240, 0.4);
}

.ntp-sync-btn:not([disabled]):hover {
  background: linear-gradient(135deg, #1c6dd0, #2d8cf0) !important;
  box-shadow: 0 8px 25px rgba(45, 140, 240, 0.6);
}

.netgun-btn:not([disabled]):hover::after {
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

/* 报警按钮特殊脉冲效果 */
.alarm-on-btn:not([disabled]) {
  animation: pulse-alarm 2s infinite;
}

@keyframes pulse-alarm {
  0%, 100% {
    box-shadow: 0 4px 15px rgba(0, 255, 136, 0.4);
  }
  50% {
    box-shadow: 0 4px 20px rgba(0, 255, 136, 0.8);
  }
}

@keyframes pulse-alarm {
  0%, 100% {
    box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);
  }
  50% {
    box-shadow: 0 4px 20px rgba(255, 107, 107, 0.8);
  }
}
}
</style>
